import {
  faChevronLeft,
  faChevronRight,
  faLocationDot,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Skeleton, Tooltip } from "@mui/material";
import moment from "moment";
import React, { FormEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import DrawerTitle from "src/Components/Drawer/DrawerTitle";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import {
  categorizeTimings,
  getInitialsImage,
} from "src/helpers/helperFunctions";
import httpRequest from "src/helpers/httpRequest";
import { CURRENCY } from "src/lib/constans";

interface IDoctoInfo {
  days: string[];
  firstName: string;
  lastName: string;
  gender: string;
  hospitalName: string;
  image: string;
  fees: string;
  appointmentType: string;
}

interface ISlots {
  id: string;
  from: string;
  to: string;
  isBooked: boolean;
  isOnline: boolean;
  isPast: boolean;
}

const getNextAvailableDays = (numDays: number, availableDays: string[]) => {
  const result = [];
  let currentDate = moment().startOf("day");
  for (let i = 0; i < numDays; i++) {
    const dayOfWeek = currentDate.format("dddd").toLowerCase();
    const formattedDate = currentDate.format("YYYY-MM-DD");
    if (availableDays.includes(dayOfWeek)) {
      result.push({
        date: formattedDate,
      });
    }
    currentDate = currentDate.add(1, "days");
  }
  return result;
};

interface IBooking {
  doctorId: string;
  hospitalId: string;
  slotId: string;
  appoinmentDate: string;
  patientName: string;
  phone?: string;
  isOnlineAppoinment: boolean;
  totalAmount: number;
  startTime: string;
  endTime: string;
}

const RescheduleAppointement = ({
  data,
  onClose,
}: {
  data: any;
  onClose: () => void;
}) => {
  const [isLoader, setIsLoader] = useState(false);
  const [doctorData, setDoctorData] = useState<IDoctoInfo | null>(null);
  const [allSlots, setAllSlots] = useState<
    { dayTime: string; slots: ISlots[] }[]
  >([]);
  const [selectedSlot, setSelectedSlot] = useState<ISlots | null>(null);
  const [slotsLoader, setSlotsLoader] = useState(false);
  const [availableDays, setAvailableDays] = useState<{
    date: string;
    totalSlots: number;
    availableSlots: number;
    bookedSlots: number;
    isAvailable: boolean;
  }[]>([]);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [rescheduleLoader, setRescheduleLoader] = useState(false);
  const [datesLoader, setDatesLoader] = useState(false);
  const [bookSlots, setBookSlots] = useState<IBooking>({
    doctorId: "",
    hospitalId: "",
    slotId: "",
    appoinmentDate: "",
    isOnlineAppoinment: false,
    totalAmount: 0,
    patientName: "",
    phone: "",
    startTime: "",
    endTime: "",
  });

  const fetchSlotsInterval = async (days: string[]) => {
    let avDays = getNextAvailableDays(30, days || []);
    setDatesLoader(true);
    const { res, err } = await httpRequest<{
      results: {
        date: string;
        totalSlots: number;
        availableSlots: number;
        bookedSlots: number;
        isAvailable: boolean;
      }[];
    }>({
      method: "post",
      path: "/appoiment/slots-count",
      params: {
        dates: avDays.map((day) => day.date),
        doctorId: data?.doctorId,
        hospitalId: data?.hospitalId,
      },
    });
    if (res) {
      let slots = res?.results;
      console.log("res", slots);
      setAvailableDays(slots);
      let date =
        slots.find((slot) => slot.availableSlots > 0)?.date || slots[0]?.date;
      setSelectedDate(date);
      if (!slotsLoader) {
        fetchSlots(date);
      }
    } else {
      toast(err, { type: "error" });
    }
    setDatesLoader(false);
  };

  const fetchDoctorInfo = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IDoctoInfo[]>({
      path: `/appoiment/doctor/slots/${data?.doctorId}/${data?.hospitalId}`,
    });
    if (res) {
      setDoctorData(res[0]);
      setBookSlots((prev) => ({
        ...prev,
        doctorId: data?.doctorId || "",
        hospitalId: data?.hospitalId || "",
        isOnlineAppoinment: res[0]?.appointmentType === "online" ? true : false,
        totalAmount: parseFloat(res[0]?.fees || "0"),
        patientName: data?.patientName || "",
        phone: data?.phone || "",
      }));
      fetchSlotsInterval(res[0]?.days || []);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const fetchSlots = async (_date: string) => {
    setSlotsLoader(true);
    const { res, err } = await httpRequest<ISlots[]>({
      method: "post",
      path: "/appoiment/doctor/slots",
      params: {
        dateAvalible: moment(new Date(_date)).toISOString(),
        doctotId: data?.doctorId,
        hospitalId: data?.hospitalId,
      },
    });
    if (res) {
      const currentMoment = moment();
      const currentDate = currentMoment.format("YYYY-MM-DD");
      const currentTime = currentMoment.format("HH:mm");

      const updatedSlots = res.map((slot) => {
        const slotDate = moment(_date).format("YYYY-MM-DD");
        const slotTime = slot.from;

        if (moment(slotDate).isBefore(currentDate)) {
          return { ...slot, isPast: true };
        }
        if (slotDate === currentDate && slotTime < currentTime) {
          return { ...slot, isPast: true };
        }
        return slot;
      });
      const { afternoonSlots, eveningSlots, morningSlots } =
        categorizeTimings(updatedSlots);
      setAllSlots([
        ...(morningSlots.length > 0
          ? [{ dayTime: "Morning", slots: morningSlots }]
          : []),
        ...(afternoonSlots.length > 0
          ? [{ dayTime: "Afternoon", slots: afternoonSlots }]
          : []),
        ...(eveningSlots.length > 0
          ? [{ dayTime: "Evening", slots: eveningSlots }]
          : []),
      ]);
      setSelectedSlot(null);
    } else {
      toast(err, { type: "error" });
    }
    setSlotsLoader(false);
  };

  useEffect(() => {
    fetchDoctorInfo();
  }, []);

  useEffect(() => {
    if (selectedDate) {
      let ele = document?.querySelector(".active-day-indicator");
      ele?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      setBookSlots((prev) => ({
        ...prev,
        appoinmentDate: selectedDate,
        slotId: selectedSlot?.id || "",
        endTime: selectedSlot?.to || "",
        startTime: selectedSlot?.from || "",
      }));
      // fetchSlots(selectedDate);
    }
  }, [selectedDate]);

  let border_Class = "border-[#E6E6E6]";

  const handleDateChange = (direction: "Next" | "Previous") => {
    if (availableDays.length === 0) return;
    const currentIndex = availableDays.findIndex(
      (day) => day.date === selectedDate
    );
    let newIndex = currentIndex;
    if (direction === "Next") {
      newIndex = (currentIndex + 1) % availableDays.length;
    } else if (direction === "Previous") {
      newIndex =
        (currentIndex - 1 + availableDays.length) % availableDays.length;
    }
    setSelectedDate(availableDays[newIndex].date);
    fetchSlots(availableDays[newIndex].date);
  };

  const reScheduleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setRescheduleLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      method: "post",
      path: "/reshedule/slots",
      params: {
        ...bookSlots,
        // comment,
        appoinmentId: data?._id || "",
      },
    });
    if (res) {
      toast(res?.message || "", { type: "success" });
      onClose();
    } else {
      toast(err, { type: "error" });
    }
    setRescheduleLoader(false);
  };

  return (
    <>
      <DrawerTitle backBtn title="Reschedule Appointment" onBack={onClose} />
      {/* <div className="flex flex-col"> */}
      <div className="side-bar-padding-3">
        <div className="box-design flex items-center side-bar-gap side-bar-padding-2">
          <div className="w-[60px] h-[60px] 2xl:w-[70px] 2xl:h-[70px] min-w-[60px] min-h-[60px] 2xl:min-w-[70px] 2xl:min-h-[70px] rounded-full relative">
            <img
              src={data?.coverPhoto || ""}
              alt="doctor"
              onError={(e) => {
                e.currentTarget.src = getInitialsImage(
                  (data?.doctorfirstName || "") +
                    " " +
                    (data?.doctorlastName || ""),
                  60,
                  35,
                  "#00443f"
                );
              }}
              className="w-full h-full object-cover rounded-full"
            />
            {/* {data?.isOnline && (
              <div className="absolute bottom-1 right-2 w-3 h-3 border border-[white] bg-green-500 rounded-full"></div>
              )} */}
          </div>
          <div className="flex flex-col flex-1">
            <p className="font-size-18px font-Poppins-Medium text-[#004540] line-clamp-1">
              {(data?.doctorfirstName || "") +
                " " +
                (data?.doctorlastName || "")}
            </p>
            <p className="font-size-14px font-Poppins-Medium text-[#202020] line-clamp-1">
              {data?.specialization?.join(" | ")}
            </p>
            <p className="line-clamp-1 font-Poppins-Regular font-size-14px text-[#878787] w-full">
              {data?.education?.join(", ")}
            </p>
          </div>
        </div>
      </div>
      <div className="w-full bg-[#F2F8FD] p-3 flex flex-col gap-3">
        <p className="text-[#262626] font-size-14px font-Poppins-Regular">
          Your Appointment Will Be Booked At This Facility
        </p>
        <div className="w-full flex gap-3 justify-between">
          <div className="flex-1 flex gap-3 items-center max-w-[calc(100%-130px)]">
            <div className="min-w-[40px] min-h-[40px] bg-[#E6EEFF] rounded-md flex items-center justify-center">
              <FontAwesomeIcon
                icon={faLocationDot}
                className="text-[#2563EB] font-size-20px"
              />
            </div>
            {!doctorData ? (
              <Skeleton variant="text" width="80%" height={30} />
            ) : (
              <p className="font-Poppins-Regular line-clamp-2 font-size-15px text-[#5B5B5B]">
                {doctorData?.hospitalName || "Unknown Hospital"}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col side-bar-padding-3 side-bar-gap">
        <div className="w-full flex flex-col gap-2">
          <h2 className="font-Poppins-Medium font-size-18px text-[#2F2F31]">
            Please Select Date & Time
          </h2>
          <div className="w-full flex gap-3 justify-between items-center">
            {!data ? (
              <Skeleton variant="text" width="30%" height={20} />
            ) : (
              <p className="font-Poppins-Medium font-size-15px text-[#2F2F31]">
                {selectedDate
                  ? moment(selectedDate).format("MMM YYYY")
                  : "No date selected"}
              </p>
            )}
            <div className="flex gap-2">
              {["Previous", "Next"].map((direction) => (
                <button
                  key={direction}
                  onClick={() =>
                    handleDateChange(direction as "Next" | "Previous")
                  }
                  className="w-[20px] h-[20px] flex items-center justify-center rounded border border-[#00443F]"
                >
                  <FontAwesomeIcon
                    icon={direction === "Next" ? faChevronRight : faChevronLeft}
                    className="text-[#00443F] font-size-13px"
                  />
                </button>
              ))}
            </div>
          </div>
          <div className="w-full flex">
            <div className="w-fit flex gap-2 overflow-x-auto scroll-hide">
              {!data || datesLoader
                ? Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      variant="rectangular"
                      width={60}
                      height={80}
                      className="rounded-xl"
                    />
                  ))
                : availableDays.map((day) => (
                    <button
                      key={day.date}
                      onClick={() => {
                        setSelectedDate(day.date);
                        fetchSlots(day.date);
                      }}
                      className={`${
                        day.date === selectedDate
                          ? "theme-gradient-green-bottom border-transparent active-day-indicator"
                          : "bg-[#F2F8FD] border-[#E6E6E6]"
                      } py-1.5 xl:py-2 px-2 xl:px-3 rounded-xl border hover:shadow-sm transition-all duration-200 ease-in-out active:scale-95`}
                    >
                      <p
                        className={`font-Poppins-Regular ${
                          day.date === selectedDate
                            ? "text-white"
                            : "text-[#5B5B5B]"
                        } font-size-13px`}
                      >
                        {moment(day.date).format("ddd")}
                      </p>
                      <p
                        className={`font-Poppins-Medium ${
                          day.date === selectedDate
                            ? "text-white"
                            : "text-[#2F2F31]"
                        } font-size-17px`}
                      >
                        {moment(day.date).format("DD")}
                      </p>
                      <p
                        className={`font-Poppins-Regular ${
                          day.date === selectedDate
                            ? "text-white"
                            : "text-[#5B5B5B]"
                        } font-size-11px whitespace-nowrap`}
                      >
                        {day.availableSlots > 0
                          ? day.availableSlots?.toString().padStart(2, "0")
                          : "No"}{" "}
                        Slots
                      </p>
                    </button>
                  ))}
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col gap-1">
          <h2 className="font-Poppins-Medium font-size-18px text-[#2F2F31]">
            {moment(selectedDate).format("dddd, MMMM DD, YYYY")}
          </h2>
          <p className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            Time Slots Are In Pakistan Standard Time (UTC +5)
          </p>
          {slotsLoader || !allSlots.length ? (
            <div className="w-full flex flex-col gap-2 mt-3">
              <Skeleton variant="text" width="20%" height={25} />
              <div className="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1.5 xl:gap-2">
                {Array.from({ length: 8 }).map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="rectangular"
                    width="100%"
                    height={40}
                    className="rounded-md"
                  />
                ))}
              </div>
            </div>
          ) : allSlots.length === 0 ? (
            <p className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
              No time slots available
            </p>
          ) : (
            allSlots.map((dayTimeSlots) => (
              <div className="w-full flex flex-col gap-2 mt-3">
                <h3 className="font-Poppins-Medium lowercase first-letter:capitalize font-size-15px text-[#2F2F31]">
                  {dayTimeSlots.dayTime}
                </h3>
                <div className="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1.5 xl:gap-2">
                  {dayTimeSlots.slots.map((slot) => (
                    <Tooltip
                      title={
                        slot?.isPast
                          ? "Time Passed"
                          : slot.isBooked
                          ? "Already Booked"
                          : "Book Appointment at " +
                            moment(slot.from, "HH:mm").format("hh:mm A")
                      }
                    >
                      <button
                        key={slot.id}
                        className={`border p-2 rounded-md ${
                          slot.isBooked || slot.isPast
                            ? "opacity-40 cursor-default"
                            : "cursor-pointer hover:shadow-sm transition-all duration-200 ease-in-out active:scale-95"
                        } ${
                          selectedSlot?.id === slot.id
                            ? "theme-gradient-green-bottom border-transparent text-white"
                            : "bg-[#F2F8FD] border-[#00443F] text-[#00443F]"
                        }`}
                        onClick={() => {
                          if (!slot.isBooked && !slot.isPast) {
                            setSelectedSlot(slot);
                            setBookSlots((prev) => ({
                              ...prev,
                              slotId: slot.id,
                              endTime: slot?.to,
                              startTime: slot?.from,
                            }));
                          }
                        }}
                      >
                        <p className="font-Poppins-Regular font-size-16px text-center">
                          {moment(slot.from, "HH:mm").format("hh:mm A")}
                        </p>
                      </button>
                    </Tooltip>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
        <BoxWrapper
          title="Appointment Details"
          titleClassName="font-Poppins-Medium-important font-size-18px-important"
        >
          <div className="flex items-end gap-2 w-full justify-between">
            {slotsLoader ? (
              <div className="flex flex-col gap-1">
                <Skeleton variant="text" width="40%" height={16} />
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="30%" height={16} />
                <Skeleton variant="text" width="50%" height={24} />
              </div>
            ) : (
              <>
                <div className="flex flex-col">
                  <p className="font-Poppins-Regular text-[#5B5B5B] font-size-13px">
                    {moment(selectedDate).format("dddd")}
                  </p>
                  <p className="font-Poppins-Medium text-[#2F2F31] font-size-17px">
                    {selectedSlot
                      ? moment(selectedSlot?.from, "HH:mm").format("hh:mm A")
                      : "--:-- --"}
                    , {moment(selectedDate).format("DD MMM")}
                  </p>
                  <p className="font-Poppins-Regular text-[#5B5B5B] font-size-15px mt-[-2px]">
                    {bookSlots.isOnlineAppoinment ? "Online" : "In Person"}
                  </p>
                </div>
                {bookSlots.isOnlineAppoinment ? (
                  <p className="font-Poppins-SemiBold text-[#2F2F31] font-size-19px">
                    <span className="font-Poppins-Regular">Fee:</span>{" "}
                    {CURRENCY}{" "}
                    {parseFloat(doctorData?.fees || "0").toLocaleString()}
                  </p>
                ) : (
                  <p className="font-Poppins-SemiBold text-[#2F2F31] font-size-19px">
                    <span className="font-Poppins-Regular">Fee:</span>{" "}
                    {CURRENCY}{" "}
                    {parseFloat(doctorData?.fees || "0").toLocaleString()}
                  </p>
                )}
              </>
            )}
          </div>
        </BoxWrapper>
      </div>
      <div className="h-[100px] w-full opacity-0">
        <div className="w-full h-full">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam,
            quos. Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Quisquam, quos.
          </p>
        </div>
      </div>

      <div className="w-full side-bar-padding-3 fixed bottom-0 left-0 shadow-all bg-white">
        <GradientBtn
          disabled={!selectedSlot}
          ButtonText="Continue"
          onPress={reScheduleSubmit}
          fontfamilyBtn="font-Poppins-Medium"
          fontsizeBtn="font-size-14px"
          btnExtraStyle={{
            width: "100%",
          }}
          loader={rescheduleLoader}
        />
      </div>
      {/* </div> */}
    </>
  );
};

export default RescheduleAppointement;
